export default {
      id: "calculate-premium-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#calculate-premium",
      toString: function () {
        return this.url;
      }
    }